export enum TimeFrameLabels {
  AllTime = 'All time',
  CurrentWeek = 'Current week',
  CurrentMonth = 'Current month',
  CurrentQuarter = 'Current quarter',
  CurrentYear = 'Current year',
  Custom = 'Custom',
  LastWeek = 'Last week',
  LastMonth = 'Last month',
  LastQuarter = 'Last quarter',
  LastYear = 'Last year',
}
